// voir pour faire un table de condition
import { IMetadatas } from '../../../../../app/apiSlice';
import { VSLabel } from '@kosmos/shared/build/cjs/types/VSLabels';

export interface IMetadatasAndLabels {
    customMedatas: ICustomMetaData[];
    labels: IMetadatas;
}

export interface ICustomMetaData {
  name: string,
  value: string,
 }  

 const useGetCustomMetaDataWithOrganisme = () => {
    
  const getCustomMetaDataWithOrganisme = (source: any, tabCondition: string[], labelsFromAPI: VSLabel[] = []): IMetadatasAndLabels => {
    let customMedatas: ICustomMetaData[] = [];
    const labelIDs = labelsFromAPI.map(l => l.id);
    const labels: IMetadatas = {};
  
    for (let metadata of source.metadonnees) {
      if (labelIDs.includes(metadata.nom)) {
          labels[metadata.nom] = metadata.valeur.includes(',') ? metadata.valeur.split(", ") : metadata.valeur;
      } else if (tabCondition.find((conditionalName) => conditionalName === metadata.nom ) === undefined) {
          customMedatas.push({name:metadata.nom, value:metadata.valeur})
      }
    }
    return {customMedatas, labels}
  }

  return {
    getCustomMetaDataWithOrganisme
  }
 }

  export default useGetCustomMetaDataWithOrganisme;